import { FC } from 'react';

import { t } from '@core/i18n';
import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { Button } from '@shared/components/button';
import { ErrorStateContent } from '@shared/components/error-state-content';

import { styles } from './SessionChangedOverlay.styles';

export type SessionChangedOverlayProps = WithStyles<typeof styles>;

const SessionChangedOverlayComponent: FC<SessionChangedOverlayProps> = ({ classes }) => {
  return (
    <div className={classes.root}>
      <ErrorStateContent
        header={t('your_session_has_changed')}
        text={t('this_tab_was_open_as_a_different_user_please_reload_the_page_to_continue')}
        actions={<Button text={t('reload_page')} onClick={() => window.location.reload()} />}
      />
    </div>
  );
};

export const SessionChangedOverlay = withStyles(styles)(SessionChangedOverlayComponent);
